import { render, staticRenderFns } from "./bo-announcement-details.vue?vue&type=template&id=4661e3b0"
import script from "./bo-announcement-details.vue?vue&type=script&lang=js"
export * from "./bo-announcement-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports